<div class="dashboard-widget-content p-2">
    <rask-alert-list
        [data]="events$"
        title="Pågående affärer">
    </rask-alert-list>
</div>
